import React, { useEffect } from "react";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import { zIndexes } from "theme/Theme";
import { useLocation } from "react-router-dom";

const AppBackdrop = () => {
  const location = useLocation();

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  const isBackdropVisible = useSelector((state: RootState) => state.appBackdrop.isBackdropVisible);

  useEffect(() => {
    if (isBackdropVisible) {
      let root = document.body;
      root.classList.add("no-scroll");

      return () => {
        root.classList.remove("no-scroll");
      };
    }
  }, [isBackdropVisible]);

  if (!isBackdropVisible || isSitemap || isLogin) {
    return null;
  }

  return <AppBackdropContainer></AppBackdropContainer>;
};

const AppBackdropContainer = styled.div`
  display: block;
  z-index: ${zIndexes.backdrop};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  animation: bg-fade-in 0.3s;
`;

export default AppBackdrop;
